import { API_URLS } from "../api_config/api_routes";
import { request } from "../api_config/api_config";

// PATIENT PAYMENT API CALLS

export const createAppointmentPaymentIntent_api = async (appointmentData) => {
  try {
    const res = await request.post(
      API_URLS.create_appointment_payment_intent_api_url,
      {
        appointmentData,
      },
    );
    if (res) {
      return res.data;
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

export const verifyPaymentStatus_api = async (paymentIntentId) => {
  try {
    const res = await request.get(
      `${API_URLS.verify_payment_status_api_url}/${paymentIntentId}`,
    );
    if (res) {
      return res.data;
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPatientTransactions_api = async ({
  patientId = null,
  searchText = null,
  startDate = null,
  endDate = null,
  offset = null,
  limit = null,
} = {}) => {
  try {
    const url = patientId
      ? `${API_URLS.get_patient_transactions_api_url}/${patientId}`
      : API_URLS.get_patient_transactions_api_url;

    const res = await request.get(url, {
      params: { searchText, startDate, endDate, offset, limit },
    });
    if (res) {
      return res.data;
    }
  } catch (error) {
    throw new Error(error.message);
  }
};
